'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppMassUnits$package$() {
  this.hR = null;
  $n_Lapp_data_AppMassUnits$package$ = this;
  this.hR = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_data_NonEmptyVector$().Em($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsquants_mass_Grams$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().d(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lsquants_mass_MassUnit.r().C)([$j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsquants_mass_Kilograms$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsquants_mass_Tonnes$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsquants_mass_Ounces$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsquants_mass_Pounds$()])));
}
export { $c_Lapp_data_AppMassUnits$package$ as $c_Lapp_data_AppMassUnits$package$ };
$p = $c_Lapp_data_AppMassUnits$package$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppMassUnits$package$;
/** @constructor */
function $h_Lapp_data_AppMassUnits$package$() {
}
export { $h_Lapp_data_AppMassUnits$package$ as $h_Lapp_data_AppMassUnits$package$ };
$h_Lapp_data_AppMassUnits$package$.prototype = $p;
var $d_Lapp_data_AppMassUnits$package$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppMassUnits$package$, "app.data.AppMassUnits$package$", ({
  Cw: 1
}));
export { $d_Lapp_data_AppMassUnits$package$ as $d_Lapp_data_AppMassUnits$package$ };
var $n_Lapp_data_AppMassUnits$package$;
function $m_Lapp_data_AppMassUnits$package$() {
  if ((!$n_Lapp_data_AppMassUnits$package$)) {
    $n_Lapp_data_AppMassUnits$package$ = new $c_Lapp_data_AppMassUnits$package$();
  }
  return $n_Lapp_data_AppMassUnits$package$;
}
export { $m_Lapp_data_AppMassUnits$package$ as $m_Lapp_data_AppMassUnits$package$ };
//# sourceMappingURL=app.data.-App-Mass-Units$package$.js.map
